import { round } from 'lodash-es';
import { Point, Sprite } from 'pixi.js-legacy';
import Constants from '../constants';
import { ScalableTextManager, ScalableTextOptions, SelectManager, SelectOptions, TooltipManager, TooltipOptions, TooltipPosition, } from '../managers';
import Textures from '../textures';
import ViewStyle from '../viewStyle';
export class ColumnOptions {
    constructor() {
        this.id = '';
        this.position = new Point(0, 0);
        this.mark = '0';
        this.viewStyle = ViewStyle.Diagram;
        this.chosenSection = '';
    }
}
export class Column extends Sprite {
    constructor(options = new ColumnOptions()) {
        if (options.viewStyle === ViewStyle.Diagram) {
            super(Textures.getInstance().ColumnDiagrammatic);
        }
        else {
            super(Textures.getInstance().ColumnDesign);
        }
        this.chosenSection = options.chosenSection;
        this.name = 'Column';
        this.id = options.id;
        this.viewStyle = options.viewStyle;
        this.position.copyFrom(options.position);
        this.width = 32;
        this.height = 32;
        this.anchor.x = 0.5;
        this.anchor.y = 0.5;
        this.tier = options.tier;
        this.mark = options.mark;
        const txtOptions = new ScalableTextOptions();
        txtOptions.text = this.mark;
        txtOptions.x = this.position.x + this.width / 2;
        txtOptions.y = this.position.y + 10;
        txtOptions.size = 40;
        txtOptions.anchor = new Point(0.5, 0.5);
        ScalableTextManager.getInstance().createText(this.tier.marks, txtOptions);
        const selectOptions = new SelectOptions();
        selectOptions.select = this.select.bind(this);
        selectOptions.deselect = this.deselect.bind(this);
        SelectManager.getInstance().addSelectable(this, selectOptions);
        const tooltipOptions = new TooltipOptions();
        tooltipOptions.text =
            `Column (${this.mark}) \n` +
                `X: ${round(this.x / Constants.scalingFactor, 3)}, ` +
                `Y: ${round(this.y / Constants.scalingFactor, 3)}\nSection: ${this.chosenSection}`;
        tooltipOptions.position = TooltipPosition.Top;
        tooltipOptions.tierOffset = this.tier.position;
        TooltipManager.getInstance().addTooltip(this, tooltipOptions);
    }
    select() {
        if (this.viewStyle === ViewStyle.Diagram) {
            this.texture = Textures.getInstance().ColumnDiagrammaticSelected;
        }
        else {
            this.texture = Textures.getInstance().ColumnDesignSelected;
        }
    }
    deselect() {
        if (this.viewStyle === ViewStyle.Diagram) {
            this.texture = Textures.getInstance().ColumnDiagrammatic;
        }
        else {
            this.texture = Textures.getInstance().ColumnDesign;
        }
    }
    diagramMode() {
        this.viewStyle = ViewStyle.Diagram;
        this.texture = Textures.getInstance().ColumnDiagrammatic;
    }
    designMode() {
        this.viewStyle = ViewStyle.Design;
        this.texture = Textures.getInstance().ColumnDesign;
    }
    destroy(options) {
        super.destroy({
            children: options.children,
            baseTexture: options.baseTexture,
        });
    }
}
